import RecaptchaUtil from "../utils/RecaptchaUtil";
import strings from "../strings";

class Contact {
	static async send(firstName, surname, email, message, phone) {
		const result = {};
		const data = {
			"first_name": firstName,
			"surname": surname,
			"email": email,
			"message": message
		};
		if (phone) data.phone = phone;

		try {
			const recaptchaToken = await RecaptchaUtil.execute("contact");
			
			if (recaptchaToken) {
				const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/sendContact`,
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							"X-Recaptcha-Token": recaptchaToken
						},
						body: JSON.stringify(data)
					}
				);

				result.status = response.status;
			} else {
				result.status = 403;
			}
		} catch (error) {
			result.status = (error.response) ? error.response.status : 500;
		} finally {
			return result;
		}
	}
}

export default Contact;
